import React from 'react';

import { connect, useSelector } from 'react-redux'
import { useState, useMemo, useEffect } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_live_registrations } from "../../../app/apiEndpoints"
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, Breadcrumb } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'
import CascadeToolToggle from '../../../containers/CascadeToolToggle';

const LiveRegistrationsTool = (props) => {
    const toolID = 17
    const [tool, setTool] = useState({})

    const [cascadeType, setCascadeType] = useState(0)
    const [cascadeError, setCascadeError] = useState("")

    const [status, setStatus] = useState(0)
    const [countdown, setCountdown] = useState(30); // seconds remaining

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [lastID, setLastID] = useState(0)
    const [reportData, setReportData] = useState([])
    const [newIDs, setNewIDs] = useState([])

    useMemo(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
                setStatus(1)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getList = async () => {
            if (toolID > 0 && status === 1) {
                setStatus(2);
                setNewIDs([])
                const data = await toolsAPICall(tool_live_registrations, {
                    requester: userID,
                    company: companyID,
                    cascadeType,
                    lastID
                });
    
                if (data.error) {
                    setCascadeError(data.error);
                } else {
                    const newData = data.registrations ?? [];
                    if (newData.length > 0) {
                        setLastID(newData[0].id);
                        setNewIDs(newData.map(row => row.id));
                        setReportData(prev => {
                            const updated = [...newData, ...prev];
                            return updated.slice(0, 50);
                        });
                    }
                    setCascadeError("");
                }
            }
        };
    
        // Run immediately
        getList();
        setCountdown(30)
    
        // Set up interval
        const pollInterval = setInterval(() => {
            setStatus(1);
        }, 30000); // every 30 seconds

        // Decrease countdown every second
        const countdownInterval = setInterval(() => {
            setCountdown(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);
    
        return () => {
            clearInterval(pollInterval);
            clearInterval(countdownInterval);
          };
    }, [toolID, userID, companyID, cascadeType, lastID, status]);


    const tableFields = useMemo(() => {
        if(reportData.length === 0) return []
        const row = reportData[0]
        const fields = Object.keys(row).map((field) => field)
        return fields
    }, [reportData]);

    const tableData = useMemo(() => {
        if(reportData.length === 0) return []
        const dataRows = []
        reportData.forEach((row, i) => {
            const values = []
            Object.keys(row).forEach((field) => values.push(row[field]))
            dataRows.push({'id': row.id, 'values': values, 'rowClass': newIDs.includes(row.id) ? 'fade-in' : ''});
        });
        //c/onsole.table(dataRows)
        return dataRows
    }, [reportData, newIDs]);

    const filterCascade = (e) => {
        let { value } = e.target;
        setCascadeType(value)
    }

    if(!tool) return <></>
    else if(cascadeError.length > 0) 
        return (
            <>
            <Breadcrumb>
              <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
              <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
            </Breadcrumb>
            <Row>
                <Col md={12}>
                    <Card>
                    <CascadeToolToggle title={tool.tool_name} description={tool.description} value={cascadeType} onChange={filterCascade} />
                        <Row>
                            <Col md={12} className="text-center">{cascadeError}</Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
            </>
        )

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
            <Card>
            <CascadeToolToggle title={tool.tool_name} description={tool.description} value={cascadeType} onChange={filterCascade} />
            <Card.Body>
            {countdown <= 0
                ? "Checking database..."
                : `Next update in: ${countdown} seconds`}

            </Card.Body>
          
            <DataTable tableID="reg" fieldNames={tableFields} dataRows={tableData} tableSettings={tableTypes.None} />
            </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(LiveRegistrationsTool), "Live Registrations"));